/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notfound_Heading_DustInputs */



/**
* | output |
* | --- |
* | "Nothing here but dust" |
*
* @param {Error_Notfound_Heading_DustInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_notfound_heading_dust = /** @type {((inputs?: Error_Notfound_Heading_DustInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notfound_Heading_DustInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Hier ist nur Staub")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Il n'y a que de la poussière ici")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("这里只剩灰尘")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("這裡只剩灰塵")
	if (locale === "ko") return /** @type {LocalizedString} */ ("먼지밖에 없습니다")
	return /** @type {LocalizedString} */ ("Nothing here but dust")
});